import React from "react";
import { NumericFormat } from "react-number-format";

function FormInput({ label, name, type, placeholder, value, onChange, error, autoComplete, required, className = "formItem" }) {
	return (
		<div className={className}>
			<label htmlFor={name}>
				{label} {required && <span className="tw-text-red-500 tw-font-bold">*</span>}
			</label>
			<input
				id={name}
				name={name}
				type={type}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				autoComplete={autoComplete}
				className={error ? "inputError" : ""}
			/>
			{error && <p className="errorMsg">{error}</p>}
		</div>
	);
}

export function NumberFormInput({ label, name, type, placeholder, value, onChange, error, autoComplete, required, className = "formItem" }) {
	return (
		<div className={className}>
			<label htmlFor={name}>
				{label} {required && <span className="tw-text-red-500 tw-font-bold">*</span>}
			</label>
			<NumericFormat
				id={name}
				name={name}
				type={type}
				placeholder={placeholder}
				value={value}
				onValueChange={(values) => onChange(values.value)}
				autoComplete={autoComplete}
				allowLeadingZeros
				valueIsNumericString
				thousandSeparator=","
				className={error ? "inputError" : ""}
			/>
			{error && <p className="errorMsg">{error}</p>}
		</div>
	);
}

export default FormInput;
